import styled from 'styled-components';

import ButtonLink from '../../interface/ButtonLink';

export const Content = styled.div`
  font-size: var(--font-size-md);
  color: var(--color-text-light);

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: var(--font-size-lg);
    max-width: 46rem;
    padding-top: 3rem;
    margin-left: 3rem;
  }
`;

export const CtaButton = styled(ButtonLink)`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
    text-align: center;
  }
`;

export const CtaButtonWrapper = styled.div`
  margin-top: 3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-top: 3.5rem;
  }
`;

export const ImageWrapper = styled.div`
  > * {
    border-radius: 8rem 8rem 8rem 0;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    max-width: 50%;
    flex: 0 0 54rem;

    > * {
      border-radius: 16rem 16rem 16rem 0;
    }
  }
`;

export const Text = styled.div`
  margin-top: 2.5rem;
  font-size: 1.6rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-top: 3.5rem;
  }
`;

export const Title = styled.h4`
  font-family: ${({ bigTitle }) => (bigTitle ? 'var(--font-secondary);' : 'var(--font-tertiary);')};
  font-weight: var(--font-weight-regular);
  font-size: ${({ bigTitle }) => (bigTitle ? '5.2rem' : '3rem')};
  line-height: 1.395;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    margin-top: 5rem;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: ${({ bigTitle }) => (bigTitle ? '6.4rem' : '3.8rem')};
  }
`;

export const Split = styled.div`
  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: flex;
    justify-content: space-between;
  }

  ${({ imagePosition }) =>
    imagePosition === 'right' &&
    `
    ${Content} {
      order: -1;
      margin-right: 3rem;
      margin-left: 0;
    }
  `}
`;
